import React from 'react';
import { Box } from '@chakra-ui/react';
import { Virtuoso } from 'react-virtuoso';
import { Bounty, BountyClaim } from '@foodfluence/shared';
import BountyCard from './BountyCard';

type Props = {
  bounties: Bounty[];
  claimsByBounty: Record<string, BountyClaim>;
  recommendedBountyIds: string[];
  invitedBountyIds: string[];
  claimingId: string | null;
  onClaim: (bounty: Bounty) => void;
  onViewClaim: (claim: BountyClaim) => void;
};

const BountyBoardList: React.FC<Props> = ({
  bounties,
  claimsByBounty,
  recommendedBountyIds,
  invitedBountyIds,
  claimingId,
  onClaim,
  onViewClaim,
}) => (
  <Virtuoso
    useWindowScroll
    data={bounties}
    computeItemKey={(_index, bounty) => bounty.id}
    increaseViewportBy={{ top: 200, bottom: 400 }}
    itemContent={(_index, bounty) => (
      <Box pb="14px">
        <BountyCard
          bounty={bounty}
          claim={claimsByBounty[bounty.id]}
          onClaim={onClaim}
          onViewClaim={onViewClaim}
          isClaiming={claimingId === bounty.id}
          isRecommended={recommendedBountyIds.includes(bounty.id)}
          isInvited={invitedBountyIds.includes(bounty.id)}
        />
      </Box>
    )}
  />
);

export default BountyBoardList;
